import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/sysRpts/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/sysRpts/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/sysRpts/Save',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/sysRpts/delete',
    method: 'post',
    data
  })
}


export function get(params) {
  return request({
    url: '/sysRpts/get',
    method: 'get',
    params
  })
}
export function newget(params) {
  return request({

    url: '/Common/Single',
    method: 'get',
    params
  })
}

